import React, { useEffect, useState } from 'react';

import { DateTimeString, track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';
import { format as fnsFormatDate, parseISO } from 'date-fns';

import Footer from '../Shared/components/Footer';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

export interface Props {
  expiredDate: DateTimeString;
}

const InvitationExpired: React.FC<React.PropsWithChildren<Props>> = ({ expiredDate }) => {
  useEffect(() => {
    track('ElementViewed', { name: 'InviteExpired', flow: 'OpenJointCheckingSecondary' });
  }, []);

  const [isSubmitting, setSubmitting] = useState(false);

  const onAck = () => {
    setSubmitting(true);
    track('ElementClicked', { name: 'GotIt', flow: 'OpenJointCheckingSecondary' });
    locationAssign(urlBuilder.appHome.absolute());
  };

  const formattedExpirationDate = fnsFormatDate(parseISO(expiredDate), 'MMMM dd, yyyy');

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="8">
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          Your Joint Checking invite expired
        </Heading>
        <Box mb="9">
          <Text as="p">
            Your Joint Checking invite expired on {formattedExpirationDate}. You can still create a Joint Checking
            account online or in the app.
          </Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <Button type="button" px="8" onClick={onAck} disabled={isSubmitting}>
            Got it
          </Button>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default InvitationExpired;
